export default function Flow() {
  const steps = [
    {
      no: "01",
      title: "web・電話・LINEで予約",
      desc: "試合日・お名前・車種・電話番号を伝えるだけ。LINEならトークで簡単予約、1分で完了。",
      icon: "ri-smartphone-line",
    },
    {
      no: "02",
      title: "駐車場へ入庫",
      desc: "アネザキカンパニー敷地内へ。スタッフが駐車スペースへご案内。受付を終えたら試合開始前までにゆったり到着。",
      icon: "ri-parking-box-line",
    },
    {
      no: "03",
      title: "シャトルで球場へ",
      desc: "無料専用シャトルでスタジアム入り口付近まで送迎。試合前のひとときも快適に。",
      icon: "ri-bus-2-line",
    },
    {
      no: "04",
      title: "観戦後、駐車場へ直行",
      desc: "試合終了後もシャトルが待機。渋滞を避けて駐車場へ戻り、スムーズに帰路へ。",
      icon: "ri-home-heart-line",
    },
  ];

  return (
    <section id="flow" className="bg-background-50 py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-3xl mx-auto reveal">
          <span className="font-heading italic text-accent-600 text-sm tracking-[0.3em] uppercase">
            How it works
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl lg:text-6xl leading-tight text-foreground-950">
            ご利用は、<br />
            <span className="italic">たった4ステップ。</span>
          </h2>
        </div>

        <div className="mt-14 md:mt-20 relative">
          <div className="hidden md:block absolute top-16 left-[12%] right-[12%] h-px bg-foreground-950/10" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-4 relative">
            {steps.map((s, i) => (
              <div key={s.no} className="text-center px-3">
                <div className="mx-auto w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-background-50 border border-background-200 relative z-10">
                  <span className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full text-2xl ${
                    i === 0 ? "bg-[#A5DEE4] text-foreground-950" : i === 1 ? "bg-primary-500 text-background-50" : i === 3 ? "bg-primary-100 text-foreground-950" : "bg-background-100 text-foreground-950"
                  }`}>
                    <i className={s.icon} />
                  </span>
                </div>
                <div className="mt-5 font-heading italic text-primary-600 text-sm tracking-widest">
                  STEP {s.no}
                </div>
                <div className="mt-1 font-heading text-xl text-foreground-950">
                  {s.title}
                </div>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}